import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FaStar } from "react-icons/fa";
import "swiper/css";
import "swiper/css/effect-coverflow";
import { EffectCoverflow, Navigation } from "swiper/modules";
import axios from "axios";
import img6 from "../../images/Img4.png";
import { BASE_URL } from "../../constant.js";
import { useNavigate } from "react-router-dom";
import "./DealOfTheDay.css";

function RelatedProducts({ title,categoryName }) {
  const navigate = useNavigate();
  const swiperRef = useRef(null);
  const [products, setProducts] = useState([]);
  const [initialSlide, setInitialSlide] = useState(0);
  const [activeSlideIndex, setActiveSlideIndex] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        console.log(categoryName);
        const response = await axios.get(
          `${BASE_URL}/api/customProducts/search-by-category?categoryName=${categoryName}`
        );
        setProducts(response.data);
        const centerSlideIndex = Math.floor(response.data.length / 2);
        setInitialSlide(centerSlideIndex);
        setActiveSlideIndex(centerSlideIndex);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };
    fetchProducts();
  }, []);

  useEffect(() => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideTo(initialSlide);
    }
  }, [initialSlide]);

  const handleMouseEnter = (index) => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideTo(index);
    }
  };

  const handleSlideChange = (swiper) => {
    setActiveSlideIndex(swiper.activeIndex);
  };

  return (
    <section className="dealday-section">
      <div className="headings" style={{ paddingTop: "20px" }}>
        <h1 className="title">{title}</h1>
      </div>
      <Swiper
        effect={"coverflow"}
        centeredSlides={true}
        grabCursor={true}
        slidesPerView={"auto"}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 2.5,
          slideShadows: false,
        }}
        autoplay={{ delay: 6000, disableOnInteraction: false }}
        initialSlide={initialSlide}
        modules={[EffectCoverflow, Navigation]}
        className="swiper_container"
        ref={swiperRef}
        speed={1000}
        touchStartPreventDefault={false}
        mousewheel={{
          releaseOnEdges: true,
          sensitivity: 5,
        }}
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }}
        onSlideChange={handleSlideChange}
      >
        {products.map((product, index) => {
          const firstPhotoUrl = product.prodImg1
            ? product.prodImg1
            : "https://balache-kapde-media.s3.ap-south-1.amazonaws.com/missing-picture-page-for-website-design-or-mobile-app-design-no-image-available-icon-vector.jpg";
          const isActive = index === activeSlideIndex;
          return (
            <SwiperSlide
              className={`dealday-card-mySwiper ${
                isActive ? "active-slide" : ""
              }`}
              key={product.productId}
              onMouseEnter={() => handleMouseEnter(index)}
            >
              <div className="dealday-card">
                <img src={firstPhotoUrl} className="swiper-slide-image" />
                {isActive && (
                  <div className="dealday-card-body">
                    <h3>{product.productName}</h3>
                    {/*<p>{product.description}</p>*/}
                    <div className="price">
                      <span style={{ display: "flex" }}>
                        <p>Rs {product.productMRP}</p>{" "}
                        <p> Rs {product.productRate}</p>
                      </span>
                      <span className="span-space">
                        <FaStar
                          style={{ color: "rgb(217, 189, 8)" }}
                          size={20}
                        />{" "}
                        <span>
                          {product.productRatings
                            ? product.productRatings.toFixed(1)
                            : "0"}
                        </span>
                      </span>
                    </div>
                  </div>
                )}
              </div>
              {isActive && (
                <button
                  className="dealday-card-btn"
                  onClick={() =>
                    navigate(`/productdetails/${product.productId}`)
                  }
                >
                  Shop Now
                </button>
              )}
            </SwiperSlide>
          );
        })}
        <div className="swiper-button-next"></div>
        <div className="swiper-button-prev"></div>
      </Swiper>
    </section>
  );
}

export default RelatedProducts;
